import React from "react";
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "../styles";
import Icon from "./Icon";

const Modal = ({ open, title, children, onClose, footer }) => {
  if (!open) return null;

  return (
    <ModalOverlay onMouseDown={onClose}>
      <ModalContainer onMouseDown={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalCloseButton onClick={onClose} aria-label="Close">
            <Icon name="x" />
          </ModalCloseButton>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
